import { API } from '@const'
import * as utils from '@utils'

export const ACTION_TYPE = {
    INIT: 'dataService.init',
    CLEAR: 'dataService.clear',
}

const defaultState = {
    hasInit: false,
    pfSubPfMap: {},
    gameList: [],
    exchangeCurrencyMap: {},
}

const DATA_KEY_ENUM = {
    SUB_PLATFORM_MAP: 0,
    GAME_LIST: 1,
    EXCHANGE_CURRENCY_MAP: 2,
}

export default (state = defaultState, action) => {
    switch (action.type) {
        case ACTION_TYPE.INIT:
            state.pfSubPfMap = {
                ...action.payloadRes[DATA_KEY_ENUM.SUB_PLATFORM_MAP],
            }
            state.gameList = [...action.payloadRes[DATA_KEY_ENUM.GAME_LIST]]
            state.exchangeCurrencyMap = {
                ...action.payloadRes[DATA_KEY_ENUM.EXCHANGE_CURRENCY_MAP],
            }

            state.hasInit = true

            if (typeof action.promiseResolve === 'function') action.promiseResolve()

            break
        case ACTION_TYPE.CLEAR:
            state = { ...defaultState }

            break
        default:
    }

    return { ...state }
}

export function init(_auth) {
    return new Promise((allResolve) => {
        Promise.all([
            new Promise((resolve, reject) =>
                utils.apiRequest(
                    'get',
                    API.SUB_PLATFORM_LIST,
                    {},
                    (data) => {
                        resolve(utils.ArrayToObject(data, 'pf_sub_pf_id'))
                    },
                    (err) => reject(err),
                    true
                )
            ),
            new Promise((resolve, reject) =>
                utils.apiRequest(
                    'get',
                    API.GAME_LIST,
                    {},
                    (data) => resolve(data),
                    (err) => reject(err),
                    true
                )
            ),
            new Promise((resolve, reject) =>
                utils.apiRequest(
                    'get',
                    API.EXCHANGE_CURRENCY_LIST,
                    {},
                    (data) => {
                        data.push({
                            currency: 'TST',
                            rate: 1,
                        })

                        resolve(utils.ArrayToObject(data, 'currency'))
                    },
                    (err) => reject(err),
                    true
                )
            ),
        ]).then((res) => {
            allResolve(res)
        })
    })
}
